const GPS_STRATEGY_TYPES = {
  ENFORCED: 'enforced',
  UNENFORCED: 'unenforced',
  WARNING: 'warning',
};
module.exports = GPS_STRATEGY_TYPES;
